// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"513":"f384625e","538":"238748db","703":"84ec2357","787":"7acb5043","983":"4600637b"}[chunkId] + ".chunk.js";
};